import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CentroContext } from "@/lib/centro";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Pacientes from "@/pages/Pacientes";
import PacienteDetalle from "@/pages/PacienteDetalle";
import Tratamientos from "@/pages/Tratamientos";
import TratamientoDetalle from "@/pages/TratamientoDetalle";
import Altas from "@/pages/Altas";
import RevisionesProgramadas from "@/pages/RevisionesProgramadas";
import PresupuestoImprimir from "@/pages/PresupuestoImprimir";
import ImprimirAparatos from "@/pages/ImprimirAparatos";
import Presupuestos from "@/pages/Presupuestos";
import SolicitudesWeb from "@/pages/SolicitudesWeb";
import Duplicados from "@/pages/Duplicados";
import Planillas from "@/pages/Planillas";
import FichaImprimir from "@/pages/FichaImprimir";
import CuestionarioImprimir from "@/pages/CuestionarioImprimir";
import FirmaProteccion from "@/pages/FirmaProteccion";
import ConsentimientoVer from "@/pages/ConsentimientoVer";
import Login from "@/pages/Login";
import Agenda from "@/pages/Agenda";
import Equipo from "@/pages/Equipo";
import Estadisticas from "@/pages/Estadisticas";
import Economico from "@/pages/Economico";
import FacturaImprimir from "@/pages/FacturaImprimir";
import AgendaImprimir from "@/pages/AgendaImprimir";
import AgendaImprimirSemana from "@/pages/AgendaImprimirSemana";
import CitasFamiliaImprimir from "@/pages/CitasFamiliaImprimir";
import ControlTerapia from "@/pages/ControlTerapia";
import { AuthProvider, RequireAuth, AuthCallback } from "@/lib/auth";

const AppRoutes = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<RequireAuth><Layout /></RequireAuth>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/equipo" element={<Equipo />} />
        <Route path="/pacientes" element={<Pacientes />} />
        <Route path="/pacientes/:id" element={<PacienteDetalle />} />
        <Route path="/tratamientos/:tipo" element={<Tratamientos />} />
        <Route path="/tratamiento/:id" element={<TratamientoDetalle />} />
        <Route path="/altas" element={<Altas />} />
        <Route path="/revisiones" element={<RevisionesProgramadas />} />
        <Route path="/control-terapia" element={<ControlTerapia />} />
        <Route path="/presupuestos" element={<Presupuestos />} />
        <Route path="/solicitudes" element={<SolicitudesWeb />} />
        <Route path="/duplicados" element={<Duplicados />} />
        <Route path="/planillas" element={<Planillas />} />
        <Route path="/estadisticas" element={<Estadisticas />} />
        <Route path="/economico" element={<Economico />} />
        <Route path="/economico/factura/:id" element={<FacturaImprimir />} />
      </Route>
      <Route path="/pacientes/:id/imprimir" element={<RequireAuth><FichaImprimir /></RequireAuth>} />
      <Route path="/agenda/imprimir" element={<RequireAuth><AgendaImprimir /></RequireAuth>} />
      <Route path="/agenda/imprimir-semana" element={<RequireAuth><AgendaImprimirSemana /></RequireAuth>} />
      <Route path="/pacientes/:id/proximas-citas" element={<RequireAuth><CitasFamiliaImprimir /></RequireAuth>} />
      <Route path="/syntonic/imprimir-aparatos" element={<RequireAuth><ImprimirAparatos /></RequireAuth>} />
      <Route path="/tomatis/imprimir-aparatos" element={<RequireAuth><ImprimirAparatos /></RequireAuth>} />
      <Route path="/cuestionarios/:id/imprimir" element={<RequireAuth><CuestionarioImprimir /></RequireAuth>} />
      <Route path="/pacientes/:id/firmar" element={<RequireAuth><FirmaProteccion /></RequireAuth>} />
      <Route path="/consentimientos/:id" element={<RequireAuth><ConsentimientoVer /></RequireAuth>} />
      <Route path="/pacientes/:id/presupuesto" element={<RequireAuth><PresupuestoImprimir /></RequireAuth>} />
    </Routes>
  );
};

function App() {
  const [centro, setCentro] = useState(() => localStorage.getItem("centro") || "");
  useEffect(() => {
    localStorage.setItem("centro", centro);
  }, [centro]);

  return (
    <CentroContext.Provider value={{ centro, setCentro }}>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="bottom-right" richColors />
    </CentroContext.Provider>
  );
}

export default App;
